import { useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseGlobalConfirm from "Hooks/UseGlobalConfirm";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import * as S from "./styles";

/*
 * Avisar a outra ponta de que o material foi aprovado — parte 4 (D4).
 *
 * O envio ao patrocinador e ao proponente é MANUAL "neste primeiro momento"
 * (decisão do cliente): só os administradores recebem e-mail automático. Aqui o
 * admin decide quando avisar.
 *
 * Molde do ResendValidationButton: é e-mail para TERCEIRO, então sempre confirma
 * antes — um clique sem querer vira incômodo para quem recebe. E, como lá, o
 * status da mensagem NÃO muda: isto é aviso, não etapa do workflow.
 *
 * Só aparece na mensagem APROVADA — o backend recusa o resto, e oferecer o botão
 * onde ele vai falhar é convite a erro.
 */
const TARGETS = {
  sponsor: {
    label: "Enviar e-mail para patrocinador",
    title: "Avisar o patrocinador?",
    message:
      "Todos os usuários da empresa patrocinadora receberão um e-mail avisando que o material foi aprovado.",
  },
  proponent: {
    label: "Enviar e-mail para proponente",
    title: "Avisar o proponente?",
    message:
      "O proponente receberá um e-mail avisando que o material foi aprovado.",
  },
};

const NotifyCounterpartButtons = ({ messageId, status }) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { addGlobalConfirm } = UseGlobalConfirm();

  const [sending, setSending] = useState(null);

  if (status !== "Aprovado" || !messageId) return null;

  const send = (target) => {
    setSending(target);

    api
      .post("/projects/messages/notify-counterpart", {
        message_id: messageId,
        target,
      })
      .then(({ data }) =>
        showNotification(
          "success",
          "Sucesso!",
          data?.message || "E-mail enviado.",
        ),
      )
      .catch((error) => HTTPErrorCallback(error))
      .finally(() => setSending(null));
  };

  const confirm = (target) =>
    addGlobalConfirm({
      type: "critical",
      title: TARGETS[target].title,
      message: TARGETS[target].message,
      confirmText: "Sim, enviar",
      denyText: "Não, cancelar",
      onClickConfirm: () => send(target),
    });

  return (
    <S.Wrapper>
      {Object.keys(TARGETS).map((target) => (
        <S.Button
          key={target}
          type="button"
          disabled={Boolean(sending)}
          onClick={() => confirm(target)}
        >
          {TARGETS[target].label}
        </S.Button>
      ))}
    </S.Wrapper>
  );
};

export default NotifyCounterpartButtons;
